/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Activation_Code_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Activation Code" |
*
* @param {Offline_Activation_Code_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_activation_code_placeholder = /** @type {((inputs?: Offline_Activation_Code_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Activation_Code_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Code d'activation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktivierungscode")
	if (locale === "it") return /** @type {LocalizedString} */ ("Codice di attivazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Код активации")
	if (locale === "es") return /** @type {LocalizedString} */ ("Código de activación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("激活码")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アクティベーションコード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एक्टिवेशन कोड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Código de ativação")
	return /** @type {LocalizedString} */ ("Activation Code")
});